if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true));
      });
      if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      if (event.detail.currentElement == undefined) return;

      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, scrollIntoView = true) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
        element.classList.remove('is-active');
        element.querySelector('button').removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

/* ==========================================================
   dermaLake + Kashier - Apple Pay Product Shortcut V2
   Product -> Shopify checkout -> active Kashier -> Apple Pay
   No Kashier secret/API key is exposed in the storefront.
   ========================================================== */
(function () {
  'use strict';

  var BUTTON_CLASS = 'dermalake-kashier-apple-pay-v2';
  var STYLE_ID = 'dermalake-kashier-apple-pay-v2-style';

  function isAppleMobile() {
    var ua = navigator.userAgent || '';
    var platform = navigator.platform || '';
    var iOSDevice = /iPhone|iPad|iPod/i.test(ua);
    var touchMac = platform === 'MacIntel' && Number(navigator.maxTouchPoints || 0) > 1;
    return iOSDevice || touchMac;
  }

  function installStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.' + BUTTON_CLASS + '{' +
        'width:100%;' +
        'min-height:56px;' +
        'margin-top:10px;' +
        'padding:0 20px;' +
        'border:0;' +
        'border-radius:14px;' +
        'background:#000;' +
        'color:#fff;' +
        'display:flex;' +
        'align-items:center;' +
        'justify-content:center;' +
        'font-family:-apple-system,BlinkMacSystemFont,"Helvetica Neue",Arial,sans-serif;' +
        'font-size:18px;' +
        'font-weight:600;' +
        'letter-spacing:.01em;' +
        'line-height:1;' +
        'cursor:pointer;' +
        '-webkit-tap-highlight-color:transparent;' +
      '}' +
      '.' + BUTTON_CLASS + ':disabled{opacity:.65;cursor:wait;}';
    document.head.appendChild(style);
  }

  function isUsableForm(form) {
    if (!form) return false;
    if (!form.querySelector('input[name="id"]')) return false;
    if ((form.id || '').indexOf('installment') !== -1) return false;
    if ((form.id || '').endsWith('--alt')) return false;
    return true;
  }

  function getMainProductForm(scope) {
    var root = scope || document;
    var preferred = Array.prototype.slice.call(
      root.querySelectorAll('product-form form[id^="product-form-"]')
    ).filter(isUsableForm);

    if (preferred.length) return preferred[0];

    var fallback = Array.prototype.slice.call(
      root.querySelectorAll('form[action*="/cart/add"]')
    ).filter(isUsableForm);

    if (!fallback.length && root !== document) {
      fallback = Array.prototype.slice.call(
        document.querySelectorAll('form[action*="/cart/add"]')
      ).filter(isUsableForm);
    }

    if (!fallback.length) return null;

    var visible = fallback.find(function (form) {
      return !!(form.offsetWidth || form.offsetHeight || form.getClientRects().length);
    });

    return visible || fallback[0];
  }

  function getVariantId(form) {
    var input = form.querySelector('input[name="id"]');
    var value = input ? String(input.value || '').trim() : '';
    return /^\d+$/.test(value) ? value : '';
  }

  function getQuantity(form) {
    var section = form.closest('.shopify-section') || document;
    var input = form.querySelector('input[name="quantity"]') ||
      section.querySelector('input[name="quantity"]');
    var qty = input ? parseInt(input.value, 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function directCheckout(form, button) {
    var variantId = getVariantId(form);
    if (!variantId) {
      button.disabled = false;
      return;
    }

    var qty = getQuantity(form);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    button.disabled = true;
    window.location.assign(
      root + 'cart/' + encodeURIComponent(variantId) + ':' + encodeURIComponent(qty)
    );
  }

  function mount(scope) {
    if (!isAppleMobile()) return;

    installStyles();

    var form = getMainProductForm(scope || document);
    if (!form) return;

    var section = form.closest('.shopify-section') || document;
    var existing = section.querySelector('.' + BUTTON_CLASS);
    var paymentButton = section.querySelector('.shopify-payment-button') ||
      form.querySelector('.shopify-payment-button');
    var addButton = form.querySelector('[name="add"]') || form.querySelector('[type="submit"]');

    if (existing) {
      if (paymentButton) paymentButton.style.setProperty('display', 'none', 'important');
      return;
    }

    if (!paymentButton && !addButton) return;

    section.querySelectorAll('.dermalake-kashier-apple-pay').forEach(function (oldButton) {
      oldButton.remove();
    });

    var button = document.createElement('button');
    button.type = 'button';
    button.className = BUTTON_CLASS;
    button.setAttribute('aria-label', 'Pay with Apple Pay');
    button.textContent = 'Pay with Apple Pay';
    button.addEventListener('click', function () {
      directCheckout(form, button);
    });

    if (paymentButton) {
      paymentButton.insertAdjacentElement('afterend', button);
      paymentButton.style.setProperty('display', 'none', 'important');
    } else {
      addButton.insertAdjacentElement('afterend', button);
    }
  }

  function boot() {
    mount(document);
    [250, 700, 1500, 3000].forEach(function (delay) {
      setTimeout(function () { mount(document); }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('page:loaded', boot);
  document.addEventListener('variant:change', function () {
    setTimeout(function () { mount(document); }, 0);
  });
  document.addEventListener('shopify:section:load', function (event) {
    setTimeout(function () { mount(event.target || document); }, 0);
  });

  if (document.documentElement && window.MutationObserver) {
    var observer = new MutationObserver(function () {
      mount(document);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 8000);
  }
})();
